import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle } from '@mui/material';

export interface ConfirmDialogProps extends Omit<DialogProps, 'title'> {
  title: React.ReactNode;
  content?: string | undefined;
  action: React.ReactNode;
  open: boolean;
  onClose: VoidFunction;
}

export function ConfirmDialog({ title, content, action, open, onClose, ...other }: ConfirmDialogProps) {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions>
        {action}

        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
